export const SET_ORDERING_EVENT_ID = 'SET_ORDERING_EVENT_ID';
export const SET_IS_PREVIEW = 'SET_IS_PREVIEW';
export const SET_ACTIVE_CART_LOCATION_SLUG = 'SET_ACTIVE_CART_LOCATION_SLUG';
export const SET_ACTIVE_SECTION = 'SET_ACTIVE_SECTION';

export function setIsPreview() {
  return (dispatch) => {
    dispatch({ type: SET_IS_PREVIEW });
  };
}

export function setConsumerActiveSection(activeSection) {
  return (dispatch) => {
    dispatch({ activeSection, type: SET_ACTIVE_SECTION });
  };
}
